import { Icon } from 'components'
import * as S from './styles'

export type NotFoundProps = {
  icon?: React.ReactNode
  title?: string
  description?: string | JSX.Element
}

export const NotFound: React.FC<NotFoundProps> = ({
  icon = <Icon icon="search-off" size="50" />,
  title,
  description
}) => {
  return (
    <S.ItemFoundInfoStyled>
      {icon}
      <span id="NoItemFoundTitle" data-testid="NotFound-title">
        {title}
      </span>
      <span id="NoItemFoundDescription" data-testid="NotFound-description">
        {description}
      </span>
    </S.ItemFoundInfoStyled>
  )
}
